const rand = (a, b) => a + Math.random() * (b - a);
const TAU = Math.PI * 2;
export const BOOM_LENGTH = 130;

const paintCanal = (w, h) => {
  const c = Object.assign(document.createElement("canvas"), { width: w, height: h });
  const g = c.getContext("2d");
  const vx = w / 2, vy = h * 0.38;
  g.fillStyle = "#0d0b0a";
  g.fillRect(0, 0, w, h);
  const wall = (pts, top, bottom) => {
    const lg = g.createLinearGradient(0, vy, 0, h);
    lg.addColorStop(0, top);
    lg.addColorStop(1, bottom);
    g.fillStyle = lg;
    g.beginPath();
    pts.forEach(([x, y], i) => (i ? g.lineTo(x, y) : g.moveTo(x, y)));
    g.fill();
  };
  wall([[0, h * 0.05], [vx - w * 0.06, vy], [vx - w * 0.1, vy + h * 0.04], [0, h * 0.75]], "#2a2724", "#46403a");
  wall([[w, h * 0.05], [vx + w * 0.06, vy], [vx + w * 0.1, vy + h * 0.04], [w, h * 0.75]], "#2a2724", "#46403a");
  wall([[0, h * 0.75], [vx - w * 0.1, vy + h * 0.04], [vx + w * 0.1, vy + h * 0.04], [w, h * 0.75], [w, h], [0, h]], "#1f1d1b", "#3a3530");
  g.strokeStyle = "rgba(0,0,0,0.45)";
  g.lineWidth = 2;
  for (let i = 1; i < 9; i++) {
    const f = i / 9;
    g.beginPath();
    g.moveTo(vx - w * 0.1 - (w * 0.4) * f * f, vy + h * 0.04 + (h * 0.71) * f * f);
    g.lineTo(vx + w * 0.1 + (w * 0.4) * f * f, vy + h * 0.04 + (h * 0.71) * f * f);
    g.stroke();
  }
  g.fillStyle = "rgba(120,140,160,0.12)";
  g.beginPath();
  g.ellipse(vx, h * 0.9, w * 0.18, h * 0.05, 0, 0, TAU);
  g.fill();
  return c;
};

export const makeBoom = (w, h, cx, cy) => ({ age: 0, cx, cy, canal: paintCanal(w, h), fire: [], smoke: [] });

const drawFire = (ctx, b, k) => {
  if (b.age < 40) for (let i = 0; i < 6; i++) b.fire.push({ x: b.cx + rand(-40, 40), y: b.cy + rand(-30, 30), r: rand(30, 90), vx: rand(-6, 6), vy: rand(-7, -1), life: 1 });
  ctx.globalCompositeOperation = "lighter";
  b.fire = b.fire.filter((f) => {
    f.x += f.vx * k; f.y += f.vy * k; f.r += 3 * k; f.life -= 0.035 * k;
    if (f.life < 0.45 && Math.random() < 0.15) b.smoke.push({ x: f.x, y: f.y, r: f.r, life: 1 });
    const hue = 15 + f.life * 40;
    const g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r);
    g.addColorStop(0, `hsla(${hue},100%,${45 + f.life * 45}%,${f.life * 0.55})`);
    g.addColorStop(1, `hsla(${hue - 10},100%,30%,0)`);
    ctx.fillStyle = g;
    ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, TAU); ctx.fill();
    return f.life > 0;
  });
  ctx.globalCompositeOperation = "source-over";
  b.smoke = b.smoke.filter((s) => {
    s.y -= 2 * k; s.r += 2 * k; s.life -= 0.02 * k;
    ctx.fillStyle = `rgba(12,10,10,${s.life * 0.35})`;
    ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, TAU); ctx.fill();
    return s.life > 0;
  });
};

export const drawBoom = (ctx, w, h, b, k) => {
  b.age += k;
  const shake = Math.max(0, 1 - b.age / 30) * 28;
  ctx.save();
  ctx.translate(rand(-shake, shake), rand(-shake, shake));
  ctx.globalCompositeOperation = "source-over";
  ctx.drawImage(b.canal, -30, -30, w + 60, h + 60);
  const heat = Math.max(0, 1 - b.age / 60);
  ctx.fillStyle = `rgba(255,90,20,${heat * 0.25})`;
  ctx.fillRect(-30, -30, w + 60, h + 60);
  drawFire(ctx, b, k);
  ctx.restore();
  ctx.globalCompositeOperation = "source-over";
  const flash = Math.max(0, 1 - b.age / 8);
  if (flash) { ctx.fillStyle = `rgba(255,250,230,${flash})`; ctx.fillRect(0, 0, w, h); }
  const vg = ctx.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.3, w / 2, h / 2, Math.max(w, h) * 0.75);
  vg.addColorStop(0, "rgba(8,12,20,0)");
  vg.addColorStop(1, "rgba(8,12,20,0.6)");
  ctx.fillStyle = vg;
  ctx.fillRect(0, 0, w, h);
  return b.age > BOOM_LENGTH;
};
